import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import api from "../../utils/api";
import Heading from "../heading";
import BodyText from "../../elements/body-text";
import PrimaryLink from "../../elements/primary-link";
import GearOrderItem from "../../sections/gear-order-item";
import CarOrderItem from "../../sections/car-order-item";
import OverviewPromoFinalizeOrder from "../../sections/overview-promo-finalize-order";
import { getOrderType, getGearOrderDetailValue, getGearOrderFieldValue, getOrderFieldValue, getPdpOrderDetailValue, getPdpOrderFieldValue, filterArrValue, filterZeroPrice } from "../../utils/processesOrderDetails";
import { staffInfoSelector, selectUserState } from "../../selectors/application";
import storeApi from "../../utils/storeApi";
import getSiteInfo from "../../utils/getSiteInfo";
import { orderTypes, planType, orderDetailsStatus } from "../../utils/lynkco-constants";

import "./style.scss";

const AccordionWrapper = ({ heading, headingOpen, orderDate, price, status = { icon: "", code: "", text: "" }, open = false, orderId, body, orderItemLabels, lang, user, invoiceLink, link1, link2, membershipLabels, delivermethods, gearItem, children, staffInfo, brandItem, finalizeOrderPreSale }) => {
  const [isOpen, setIsOpen] = useState(open);

  const [items, setItems] = useState([]);

  const [downloadLink, setDownloadLink] = useState(null);
  const [invoiceDocumentLink, setInvoiceDocumentLink] = useState(null);
  const [orderType, setOrderType] = useState("presale");
  const [gearsOrder, setGearsOrder] = useState(null);
  const [pdpOrder, setPdpOrder] = useState(null);
  const [orderDetailStatus, setOrderDetailStatus] = useState(null);
  const [showFinalizeOrder, setShowFinalizeOrder] = useState(false);
  const [orderLang, setOrderLang] = useState();
  const [orderOrgId, setOrderOrgId] = useState();
  const [orderMarket, setOrderMarket] = useState();
  const [santanderURL, setSantanderURL] = useState(null);

  const accordionWrapperTitleClassList = classNames("orders-accordion-wrapper-title", {
    open: isOpen
  });

  const accordionContentClassList = classNames("orders-accordion-wrapper-content", {
    open: isOpen
  });

  const openIconClassList = classNames("add", {
    open: isOpen
  });
  useEffect(() => {
    getOrderDetail();
  }, [isOpen, staffInfo]);

  const renderComplexOrderItem = (item, orderIndex) => {
    switch (item.type) {
      case "GearOrders":
        return (
          <div className="order-row--gear" key={`order-${orderIndex}`}>
            {item.orderItems.map((gear, index) => (
              <GearOrderItem {...gear} key={gear.name + index} />
            ))}
          </div>
        );
      case "CarOrders":
        return (
          <div className="order-row--car" key={`order-${orderIndex}`}>
            {item?.orderItems?.map((car, index) => (
              <CarOrderItem {...car} key={index} />
            ))}
          </div>
        );
      default:
        return null;
    }
  };
  const { gearItemLabels, detailsItem, moreInfo } = gearItem;
  const gearOrderDetail = () => {
    return (
      <>
        {moreInfo && <BodyText className="order-more-info" html={moreInfo} />}
        {gearsOrder.description && <BodyText html={gearsOrder.description} className="order-description" />}
        {gearsOrder.items &&
          gearsOrder?.items?.map(item => {
            const { label, value, html } = item;
            return value === "html" ? (
              renderComplexOrderItem(item)
            ) : (
              <div className="order-row" key={label + value}>
                <div className="label">{label}</div>
                <div
                  className="value"
                  dangerouslySetInnerHTML={{
                    __html: value
                  }}
                />
              </div>
            );
          })}
      </>
    );
  };
  const pdpOrderDetail = () => {
    const { moreInfo, finalizeOrder, santanderButton, loanApprovedFinalize, loanRejectedFinalize, pdpItemLabels, detailsItem, description } = brandItem;
    let finalizeOrderNew = null;
    if (orderType === "buyACarLoan") {
      if (orderDetailStatus === orderDetailsStatus.loanApproved) {
        finalizeOrderNew = loanApprovedFinalize;
      }
      finalizeOrderNew = { ...finalizeOrderNew, orderLang, orderOrgId, orderMarket };
    }
    return (
      <>
        {moreInfo && <BodyText className="order-more-info" html={moreInfo} />}
        {description && <BodyText html={description} className="order-description" />}
        {finalizeOrderNew && (
          <div className="finalize-order">
            <OverviewPromoFinalizeOrder {...finalizeOrderNew} />
          </div>
        )}
        {pdpOrder?.map(item => {
          const { label, value, html } = item;
          return html ? (
            renderComplexOrderItem(item)
          ) : (
            <div className="order-row" key={label + value}>
              <div className="label">{label}</div>
              <div
                className="value"
                dangerouslySetInnerHTML={{
                  __html: value
                }}
              />
            </div>
          );
        })}
        {santanderURL && <PrimaryLink {...{ ...santanderButton, link: { value: { href: santanderURL, target: "_blank" } } }} />}
      </>
    );
  };

  const getOrderDetail = async () => {
    let req = null;
    if (!isOpen) return null;
    if (staffInfo) {
      req = storeApi.order.detail(null, { id: orderId });
    } else {
      req = api.order.detail(null, {
        id: orderId
      });
    }

    const siteInfo = await getSiteInfo();
    isOpen &&
      req.then(res => {
        if (res && res.obj) {
          let _orderType = getOrderType(res.obj.subType);
          let language = res.obj?.country ? `${res.obj?.language}-${res.obj?.country}` : res.obj?.language;
          if (_orderType === "gears") {
            let _items = gearItemLabels?.map(x => ({
              label: x.value,
              value: getGearOrderFieldValue(x.key, res.obj, lang, delivermethods, siteInfo.dateFormat)
            }));
            let gearOrder = {
              label: "gearProductData",
              value: "html",
              type: "GearOrders",
              orderItems: getGearOrderDetailValue({ detailsItem, res: res.obj })
            };
            let gearProductDataIndex = _items?.findIndex(x => x.value === "html");
            _items[gearProductDataIndex] = gearOrder;
            _items = filterArrValue(_items);
            setGearsOrder({
              items: _items
            });
            const gearOrderType = "gearssale";
            if (res.obj.isCaptured === "1") {
              let _link1 = gearItem.link1;
              _link1.link.value.href = `/${lang}/PdfView?type=${gearOrderType}&pageFormat=A4&orderNo=${res.obj.orderNo}`;
              let invoiceLink = gearItem.invoiceLink;
              invoiceLink.link.value.href = res.obj.invoiceDocumentLink;
              setDownloadLink(_link1);
              setInvoiceDocumentLink(invoiceLink);
            }
          } else if (_orderType === "presale") {
            setOrderLang(res.obj?.language);
            setOrderOrgId(res.obj?.orgId);
            setOrderMarket(res.obj?.country);
            let _items = orderItemLabels?.map(x => ({
              label: x.value,
              value: getOrderFieldValue(x.key, res.obj, lang, membershipLabels, siteInfo.dateFormat)
            }));
            _items = filterArrValue(_items);
            setItems(_items);
            if (res.obj.isCaptured === "1") {
              link1.link.value.href = `/${lang}/PdfView?type=${_orderType}&pageFormat=A4&orderNo=${res.obj.orderNo}`;
              setDownloadLink(link1);
              invoiceLink.link.value.href = res.obj.invoiceDocumentLink;
              setInvoiceDocumentLink(invoiceLink);
            }
          } else if (_orderType) {
            setOrderLang(res.obj?.language);
            setOrderMarket(res.obj?.country);
            setOrderOrgId(res.obj?.orgId);
            const { pdpItemLabels, detailsItem, receiptLink, invoiceLink, yesValue } = brandItem;
            let _items =
              pdpItemLabels?.map(x => ({
                label: x.value,
                value: getPdpOrderFieldValue(x.key, res.obj, lang, delivermethods, siteInfo.dateFormat)
              })) || [];
            let pdpOrder = {
              label: "PdpProductData",
              html: true,
              type: "CarOrders",
              orderItems: getPdpOrderDetailValue({ detailsItem, res: res.obj, yesValue })
            };
            let pdpType = "";
            let gearProductDataIndex = _items.findIndex(x => x.value === "html");
            _items[gearProductDataIndex] = pdpOrder;
            switch (res.obj.subType) {
              case orderTypes?.monthToMonth:
                pdpType = planType?.MtM;
                break;
              case orderTypes?.buyACarLoan:
              case orderTypes?.buyACarCash:
                pdpType = planType?.BaC;
                break;
              default:
                break;
            }
            _items = filterZeroPrice(_items, language);
            _items = filterArrValue(_items);
            setPdpOrder(_items);
            setOrderDetailStatus(res?.obj?.detailedOrderStatus);
            if (res.obj.isCaptured === "1" && receiptLink) {
              let _link1 = receiptLink;
              _link1.link.value.href = `/${lang}/PdfView?type=${pdpType}&pageFormat=A4&orderNo=${res.obj.orderNo}`;
              let invoiceLinkNew = invoiceLink;
              invoiceLinkNew.link.value.href = res.obj.invoiceDocumentLink;
              setDownloadLink(_link1);
              setInvoiceDocumentLink(invoiceLinkNew);
            }
            if (res.obj?.orderExtraData?.santanderURL) {
              setSantanderURL(res.obj?.orderExtraData?.santanderURL);
            }
          }
          setOrderType(_orderType);
          if (((status.code == "ORDERSTATUSTOC03" && res?.obj?.isPresaleFinalized === "0" && user?.membershipCode === "MEMBERSHIP04") || user?.membershipCode === "MEMBERSHIP02") && _orderType === "presale") {
            setShowFinalizeOrder(true);
          } else {
            setShowFinalizeOrder(false);
          }
        }
      });
  };
  const priceClassList = classNames("price", {
    cancel: status.code === "ORDERSTATUSTOC02"
  });
  return (
    <div className="orders-accordion-wrapper">
      <div className={accordionWrapperTitleClassList} onClick={() => setIsOpen(!isOpen)}>
        <div className="title-group">
          <div className="heading">{isOpen && headingOpen ? <Heading {...headingOpen} /> : <Heading {...heading} />}</div>
          <div className="icon-group-status">
            <div className="status-indication">
              {status.icon?.svg && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: status.icon.svg
                  }}
                />
              )}
              {status.text && <span>{status.text}</span>}
            </div>
          </div>
        </div>

        <div className="title-group sub">
          <div className="heading">
            <BodyText html={orderDate} className="sub-body" />
          </div>
          <div className={priceClassList}>
            <BodyText html={price} className="sub-body" />
          </div>
        </div>
        <div className="icon-group">
          <span className={openIconClassList}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
            </svg>
          </span>
        </div>
      </div>
      <div className={accordionContentClassList}>
        <div className="order-content">
          {showFinalizeOrder && <OverviewPromoFinalizeOrder {...{ ...finalizeOrderPreSale, membershipPlanCode: finalizeOrderPreSale?.membershipDataConfig?.fields?.bacMembershipTypeId?.fields?.phrase?.value, orderLang, orderOrgId, orderMarket }} />}
          {orderType === "gears" && gearOrderDetail()}
          {orderType === "presale" &&
            items.map(({ label, value }, key) => {
              return (
                value && (
                  <div className="order-row" key={label + value + key}>
                    <div className="label">{label}</div>
                    <div className="value">{value}</div>
                  </div>
                )
              );
            })}
          {orderType && orderType !== "presale" && orderType !== "gears" && pdpOrderDetail()}
          {downloadLink && <PrimaryLink {...downloadLink} />}
          {invoiceDocumentLink && <PrimaryLink {...invoiceDocumentLink} />}
          {orderType === "presale" && link2 && <PrimaryLink {...link2} />}
          {orderType && orderType !== "presale" && orderType !== "gears" && brandItem?.detailsLink && <PrimaryLink {...brandItem?.detailsLink} />}
          {orderType === "gears" && <BodyText html={gearItem.body} />}
          {orderType === "presale" && <BodyText html={body} />}
          {orderType && orderType !== "presale" && orderType !== "gears" && <BodyText html={brandItem.body} />}
          {children}
        </div>
      </div>
    </div>
  );
};

AccordionWrapper.propTypes = {
  heading: PropTypes.object,
  headingOpen: PropTypes.object,
  status: PropTypes.shape({
    icon: PropTypes.object,
    text: PropTypes.string
  }),
  open: PropTypes.bool
};

const mapStateToProps = state => ({
  user: selectUserState(state),
  staffInfo: staffInfoSelector(state)
});
export default connect(mapStateToProps)(AccordionWrapper);
